<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="csaViolationForm">
        <div class="my-section-box__headline">{{ 'common.airDiscBrake_value_calculator_CSA_violation' | cxTranslate }}
        </div>
        <div class="my-section-box fleetInfo" id="fleetInfo">
          <div class="my-section-box-inner">
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="csaViolationsAnnualPercentage">
                  {{ 'common.airDiscBrake_value_calculator_csaViolationsAnnualPercentage' | cxTranslate }}*
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="number" formControlName="csaViolationsAnnualPercentage"
                      (keyup)="calculateAndSetSum()" />
                      @if (form.csaViolationsAnnualPercentage.invalid && (form.csaViolationsAnnualPercentage.dirty || form.csaViolationsAnnualPercentage.touched)) {
                        <span class="text-danger-show"
                          >
                        {{'common.form_field_required'|cxTranslate}}</span>
                      }
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                      %
                      <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_csaViolationsAnnualPercentage',
                                   'common.airDiscBrake_value_calculator_popup_csaViolationsAnnualPercentage')"
                          class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="Air Disc CSA Violation Service">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                  <label class="form-label" for="noOfCSAViolations">
                    {{ 'common.airDiscBrake_value_calculator_numberofCSAViolations' | cxTranslate }}
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-8 col-xs-8 col-sm-6 pr-0">
                      <input type="number" formControlName="noOfCSAViolations" readonly />
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                      {{ 'common.airdiscBrake_value_calculator_violations_text' | cxTranslate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row col-12">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                  <label class="form-label" for="roadSideCallRateForCSAViolations">
                    {{ 'common.airDiscBrake_value_calculator_roadsideCallRateForCSAViolation' | cxTranslate}}
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-8 col-xs-8 col-sm-6 pr-0">
                      <input type="text" formControlName="roadSideCallRateForCSAViolations" (keyup)="calculateAndSetSum()"
                        appNumberFormat />
                        @if (form.roadSideCallRateForCSAViolations.invalid && (form.roadSideCallRateForCSAViolations.dirty || form.roadSideCallRateForCSAViolations.touched)) {
                          <span class="text-danger-show"
                            >
                          {{'common.form_field_required'|cxTranslate}}</span>
                        }
                      </div>
                      <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                        {{ 'common.value_calculator_usdOcc_text' | cxTranslate }}
                        <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_roadsideCallRateForCSAViolation',
                                   'common.airDiscBrake_value_calculator_popup_roadsideCallRateForCSAViolation')"
                            class="btn-link">
                            <img src="/icons/question_dark_kb.svg" alt="Air Disc CSA Violation Service">
                          </span>
                        </mat-dialog-actions>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                    <label class="form-label" for="annualnoOfOutOfServiceBreakCSAViolations">
                      {{ 'common.airDiscBrake_value_calculator_annualNoOfOutOfServiceBrakeCSAViolations' | cxTranslate}}
                    </label>
                    <div class="col-12 px-0 row">
                      <div class="col-8 col-xs-8 col-sm-6 pr-0">
                        <input type="number" formControlName="annualnoOfOutOfServiceBreakCSAViolations" readonly />
                      </div>
                      <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                        {{ 'common.airdiscBrake_value_calculator_violations_text' | cxTranslate }}
                        <mat-dialog-actions>
                          <span
                        (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_annualNoOfOutOfServiceBrakeCSAViolations',
                                   'common.airDiscBrake_value_calculator_popup_annualNoOfOutOfServiceBrakeCSAViolations')"
                            class="btn-link">
                            <img src="/icons/question_dark_kb.svg" alt="Air Disc CSA Violation Service">
                          </span>
                        </mat-dialog-actions>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row  col-12">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                    <label class="form-label" for="csaUnitCost">
                      {{ 'common.airDiscBrake_value_calculator_CSAUnitCost' | cxTranslate}}
                    </label>
                    <div class="col-12 px-0 row">
                      <div class="col-8 col-xs-8 col-sm-6 pr-0">
                        <input type="number" formControlName="csaUnitCost" readonly />
                      </div>
                      <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                        {{ 'common.airDiscBrake_value_calculator_usd_unit' | cxTranslate }}
                        <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_CSAUnitCost',
                                   'common.airDiscBrake_value_calculator_popup_CSAUnitCost')" class="btn-link">
                            <img src="/icons/question_dark_kb.svg" alt="Air Disc CSA Violation Service">
                          </span>
                        </mat-dialog-actions>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                    <label class="form-label" for="lifeCycleCSAFleetCost">
                      {{ 'common.airDiscBrake_value_calculator_lifecycleCSAFleetCost' | cxTranslate}}
                    </label>
                    <div class="col-12 px-0 row">
                      <div class="col-8 col-xs-8 col-sm-6 pr-0">
                        <input type="number" formControlName="lifeCycleCSAFleetCost" readonly />
                      </div>
                      <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                        {{ 'common.text_smartire_usd' | cxTranslate }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="airdisk-button-block">
                  <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                    (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow" alt="Back">
                  {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
                  <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                    (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                    <img src="/icons/link-right-white.svg" class="right-arrow" alt="Next"></button>
                  </div>
                </div>
              </div>
            </form>
          }
        </div>
      </div>